import {
  toCheckoutReturnUrl,
  type PlanBillingInterval,
  type UpgradePlanName,
} from '@workspace/global-utils';
import { toast } from '@workspace/ui/components/sonner';
import { authenticatedNextFetch } from '@/api/api-service';
import { openBillingForCredits } from '@/lib/credit-guard';

// Sends the user to Dodo checkout for one plan and back to this page afterwards (or `returnUrl`).
// Checkout can't start for a workspace that already has a subscription (plan changes need the
// proration preview) or a member without billing access, so those finish on the billing page.
export async function startPlanCheckout(
  plan: UpgradePlanName,
  interval: PlanBillingInterval,
  currency?: string,
  returnUrl?: string,
) {
  try {
    const response = await authenticatedNextFetch('/api/billing/plan-checkout', {
      method: 'POST',
      body: JSON.stringify({
        plan,
        interval,
        currency,
        returnUrl: toCheckoutReturnUrl(returnUrl ?? window.location.href),
      }),
    });
    const payload = (await response.json().catch(() => ({}))) as { url?: string };
    if (response.ok && payload.url) {
      window.location.href = payload.url;
      return;
    }
  } catch {
    toast.error('We couldn’t open checkout. Taking you to billing instead.');
  }
  openBillingForCredits(null);
}
